import script from "./Sending.vue?vue&type=script&setup=true&lang=js"
export * from "./Sending.vue?vue&type=script&setup=true&lang=js"

import "./Sending.vue?vue&type=style&index=0&id=619d4226&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619d4226"]])

export default __exports__